export const isAionPreviewHostname = (hostname = "") =>
  /aion-frontend-preview-production\.up\.railway\.app$/i.test(String(hostname || ""));

export const shouldConnectRealtime = ({
  hostname = "",
  isTrustCenterView = false,
} = {}) => !isTrustCenterView && !isAionPreviewHostname(hostname);
